export default "__VITE_ASSET__676fa298__"